import { css } from '@emotion/core';
import { rgba, tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
export var mobileCTA = /*#__PURE__*/css("display:flex;flex-direction:row;justify-content:stretch;gap:12px;width:100%;overflow:hidden;padding:16px 24px;box-shadow:0 -4px 20px 0 ", rgba(colors.neutral.heavy.default, 0.1), ";background:", colors.neutral.surface.default, ";");

// A container to hold the buttons so that they can be equal-sized flexbox children
export var buttonContainer = {
  name: "1rr4qq7",
  styles: "flex:1;"
};
export var button = {
  name: "8atqhb",
  styles: "width:100%;"
};